import { Suspense, lazy } from 'react'
import { Routes, Route } from 'react-router-dom'
import Header from '../components/Header/Header'
import Footer from '../components/Footer/Footer'
import ScrollToTop from '../components/Common/ScrollToTop'
import { I18nProvider } from '../utils/i18n'
import '../styles/variables.css'
import '../styles/global.css'
import './App.css'

const Home = lazy(() => import('./Home/Home'))
const Services = lazy(() => import('./Services/Services'))
const ServiceDetail = lazy(() => import('./Services/ServiceDetail'))
const CourseGeneralPlaceholder = lazy(() => import('./Services/CourseGeneralPlaceholder'))
const About = lazy(() => import('./About/About'))
const Contact = lazy(() => import('./Contact/Contact'))
const Quote = lazy(() => import('./Quote/Quote'))
const FAQ = lazy(() => import('./FAQ/FAQ'))
const Courses = lazy(() => import('./Courses/Courses'))
const GovernmentNews = lazy(() => import('./GovernmentNews/GovernmentNews'))
const PublicationDetail = lazy(() => import('./Publications/PublicationDetail'))
const Login = lazy(() => import('./Auth/Login'))
const Register = lazy(() => import('./Auth/Register'))
const PortalDashboard = lazy(() => import('./Portal/PortalDashboard'))
const PortalRequests = lazy(() => import('./Portal/PortalRequests'))
const PortalPreferences = lazy(() => import('./Portal/PortalPreferences'))
const Sectors = lazy(() => import('./Sectors/Sectors'))
const SectorDetail = lazy(() => import('./Sectors/SectorDetail'))
const PrivacyPolicy = lazy(() => import('./Legal/PrivacyPolicy'))
const CookiePolicy = lazy(() => import('./Legal/CookiePolicy'))
const TermsOfService = lazy(() => import('./Legal/TermsOfService'))

const Loading = () => (
  <div className="page-loading">
    <span className="spinner" />
    <p>Chargement...</p>
  </div>
)

export default function App () {
  return (
    <I18nProvider>
      <ScrollToTop />
      <div className="app-shell">
        <Header />
        <main>
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/cours/general" element={<CourseGeneralPlaceholder />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/quote" element={<Quote />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/legal-updates" element={<GovernmentNews />} />
              <Route path="/publications/:slug" element={<PublicationDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/portal" element={<PortalDashboard />} />
              <Route path="/portal/requests" element={<PortalRequests />} />
              <Route path="/portal/preferences" element={<PortalPreferences />} />
              <Route path="/secteurs" element={<Sectors />} />
              <Route path="/secteurs/:slug" element={<SectorDetail />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/cookies" element={<CookiePolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </div>
    </I18nProvider>
  )
}
